<!--  -->
<template>
  <div>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="活动名称" prop="acname">
        <el-input
          v-model="ruleForm.acname"
          v-model.trim="ruleForm.acname"
          style="width: 300px"
          @input="ruleForm.acname = ruleForm.acname.replace(reg, '')"
        />
      </el-form-item>
      <el-form-item label="赠送道具" prop="resource_type">
        <el-select
          v-model="ruleForm.resource_type"
          placeholder="请选择赠送道具"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="赠送书券量" prop="amount">
        <el-input
          v-model="ruleForm.amount"
          style="width: 300px"
          type="number"
          min="1"
          max="1000"
          @blur="chaer"
        />
      </el-form-item>
      <el-form-item label="书券有效期" prop="expire">
        <el-input
          v-model="ruleForm.expire"
          style="width: 300px"
          type="number"
          min="1"
          max="7"
          @blur="expirechaer"
        />(天)
      </el-form-item>
      <el-form-item label="赠送名额" prop="totalGift">
        <el-input
          v-model="ruleForm.totalGift"
          style="width: 300px"
          type="number"
          min="0"
          max="10000"
          @blur="giftchaer"
        />
      </el-form-item>
      <el-form-item label="期限选择">
        <el-select v-model="time_type" placeholder="请选择">
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="time_type === 2" label="固定天数" prop="appoint_day">
        <el-input
          v-model="ruleForm.appoint_day"
          style="width: 300px"
          placeholder="请输入固定天数"
          type="number"
          :onkeyup="
            (ruleForm.appoint_day = ruleForm.appoint_day.replace(
              /[^A-z0-9]/,
              ''
            ))
          "
        />
      </el-form-item>
      <el-form-item v-if="time_type === 1" label="活动有效期" prop="timearr">
        <el-date-picker
          v-model="ruleForm.timearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue"
        />
      </el-form-item>
      <el-form-item label="活动展示位" prop="open_banner">
        <el-radio
          v-model="ruleForm.open_banner"
          :label="1"
        >阅读页banner</el-radio>
      </el-form-item>

      <el-form-item label="用户圈定" prop="open_banner">
        <el-radio-group v-model="ruleForm.user_filte">
          <div class="dada">
            <el-radio :label="0">任意用户：无门槛限制</el-radio>
          </div>
          <div class="dada">
            <el-radio
              :label="1"
            >老用户：注册2天及以上的用户（排除48小时新用户）</el-radio>
          </div>
          <div class="dada">
            <el-radio
              :label="2"
            >全量未充值用户（排除新用户）：注册2天及以上&从未充值用户</el-radio>
          </div>
          <div class="dada">
            <el-radio
              :label="3"
            >1周未充值用户：注册7天及以上&7天内未充值用户</el-radio>
          </div>
          <div class="dada">
            <el-radio
              :label="4"
            >2周未充值用户：注册14天及以上&14天内未充值用户</el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
      <div class="illustrate_box">
        <div class="rwew">说明</div>
        <div class="rwew">1.默认0点开始+24点结束，单次活动最多在线30天。</div>
        <div class="rwew">
          2.用户圈定仅限制活动运营位展示，不限制用户参与机会（即非标签范围内的用户不可见书城内该活动的运营位，但可通过链接参与该活动）。
        </div>
      </div>

      <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { readingservice } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAge = (rule, value, callback) => {
      console.log(this.ruleForm.timearr[0])
      console.log(this.ruleForm.timearr[1])
      // var date = new Date('2022-10-15 00:00:00')
      // var dater = new Date('2022-11-13 23:59:59')
      var date = new Date(this.ruleForm.timearr[0])
      var dater = new Date(this.ruleForm.timearr[1])
      var time1 = date.getTime() // 开始时间
      var time2 = dater.getTime() // 结束时间
      var time3 = time2 - time1 // 对
      // 计算30天的时间为毫秒
      var time4 = 1000 * 3600 * 24 * 30
      if (time3 < time4) {
        console.log('111小于30')
        callback()
      } else {
        callback(new Error('活动时间最长为30天'))
        // console.log('222大于30')
      }
    }
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      ruleForm: {
        acname: '',
        resource_type: 1,
        amount: '',
        expire: '',
        totalGift: '',
        timearr: [],
        open_banner: 0,
        user_filte: 0,
        appoint_day: ''
      },
      starttime: '',
      endtime: '',
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        },
        {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2,
      rules: {
        acname: [
          { required: true, message: '请输入活动标题', trigger: 'blur' }
        ],
        resource_type: [
          { required: true, message: '请选择赠送道具', trigger: 'change' }
        ],
        amount: [
          { required: true, message: '请输入赠送书券量', trigger: 'blur' }
        ],
        expire: [
          { required: true, message: '请输入书券有效期', trigger: 'blur' }
        ],
        totalGift: [
          { required: true, message: '请输入赠送名额', trigger: 'blur' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ],
        timearr: [
          {
            type: 'array',
            required: true,
            message: '请选择时间',
            trigger: 'change'
          },
          { validator: checkAge, trigger: 'change' }
        ]
      },
      options: [
        {
          value: 1,
          label: '书券'
        }
      ],
      pickerOptions: {
        // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    cancel() {
      this.$emit('close')
    },
    submitForm(formName) {
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!')
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.starttime
            par.end_time = this.endtime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.ruleForm.appoint_day)
          }
          console.log('this.platformid', this.platformid)
          readingservice({
            platform_id: this.platformid,
            activity_type: 4,
            ...par,
            activity_info: {
              acname: this.ruleForm.acname,
              resource_type: this.ruleForm.resource_type,
              amount: this.ruleForm.amount,
              once: this.ruleForm.once,
              expire: this.ruleForm.expire,
              totalGift: this.ruleForm.totalGift,
              // start_time: this.starttime,
              // end_time: this.endtime,
              open_banner: this.ruleForm.open_banner,
              user_filte: this.ruleForm.user_filte
            }
          }).then((res) => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.$emit('close')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    chaer() {
      console.log('3333')
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.amount < 1 && this.ruleForm.amount != '') {
        console.log('2222')
        this.ruleForm.amount = 1
      }
      // 判断不能输入小数点
      const str = '' + this.ruleForm.amount
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.ruleForm.amount = 1
      }
      if (this.ruleForm.amount > 1000) {
        this.ruleForm.amount = 1000
      }
    },
    expirechaer() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.expire < 1 && this.ruleForm.expire != '') {
        this.ruleForm.expire = 1
      }
      // 判断不能输入小数点
      const str = '' + this.ruleForm.expire
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.ruleForm.expire = 1
      }
      if (this.ruleForm.expire > 7) {
        this.ruleForm.expire = 7
      }
    },
    giftchaer() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.totalGift < 0 && this.ruleForm.totalGift != '') {
        this.ruleForm.totalGift = 0
      }
      // 判断不能输入小数点
      const str = '' + this.ruleForm.totalGift
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.ruleForm.totalGift = 0
      }
      if (this.ruleForm.totalGift > 10000) {
        this.ruleForm.totalGift = 10000
      }
    },
    datavalue(val) {
      // this.starttime = val[0].substring(0, 10)
      // this.endtime = val[1].substring(0, 10)
      this.starttime = val[0]
      this.endtime = val[1]
      console.log(this.starttime, this.endtime)
    }
  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
.ribbon_box {
  margin-top: 40px;
  text-align: right;
}
.dada {
  margin-bottom: 10px;
}
.illustrate_box {
  margin-top: 10px;
  padding-left: 15px;
  margin-bottom: 20px;
}
.rwew {
  margin-bottom: 10px;
  color: #bbb;
}
/deep/ .el-input__inner::-webkit-outer-spin-button,
/deep/ .el-input__inner::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/ .el-input__inner[type='number'] {
  -moz-appearance: textfield;
}
@media (max-width: 768px) {
  .asdatw,
  .acwc_name ,.el-radio__label{
    font-size: 2.8vw;
  }.asdatw,
  .el-radio-group .dada .el-radio__label {
    font-size: 2.8vw !important;
  }
}
</style>
